
$(document).ready(function () {
  countDownIni('.flip-countdown,.js-flip-countdown'); 
    //***** header layout nine  *****//
  function responsiveMenu() {
    if (jQuery(window).width() < 1301) {
      $('.header-style-nine .header-icon').prependTo('.header-style-nine .menu-item-right');
    }
    else {
      $('.header-style-nine .header-icon').prependTo('.header-style-nine .header-sticky');
    }
    if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
    }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
    }
  }
  jQuery(document).ready(function () {
    responsiveMenu();
  });
  jQuery(window).resize(function () {
    responsiveMenu();
  });
  
  /******   HEADER TEN TOGGLE ******/
  $(".header-style-ten .menu-item-left .btn-secondary").click(function () {
    $(".site-nav").toggleClass("active");
  });
  /********* Announcebar hide ********/
  $('#announceclose').click(function () {
    $('.announcebar').slideUp("slow");
  });
  /********* On scroll heder Sticky *********/
function initHeaderSticky() {
  if (jQuery(document).height() > jQuery(window).height()) {
    if (jQuery('.site-header .main-navigationbar, .header-style-five .logobar, .header-style-six .logobar').hasClass("sticky_header")) {
      if (jQuery(this).scrollTop() > 100) {
        jQuery('.site-header .main-navigationbar').addClass("fixed");
        jQuery('.header-style-five .logobar, .header-style-six .logobar').addClass("fixed");
        jQuery('.header-style-five .main-navigationbar, .header-style-six .main-navigationbar').removeClass("fixed");
      } else {
        jQuery('.site-header .main-navigationbar').removeClass("fixed");
        jQuery('.header-style-five .logobar, .header-style-six .logobar').removeClass("fixed");
      }
    } else {
      jQuery('.site-header .main-navigationbar').removeClass("fixed");
      jQuery('.header-style-five .logobar, .header-style-six .logobar').removeClass("fixed");
    }
  }
}
$(document).ready(function () {
  initHeaderSticky()
});
$(window).resize(function () {
  initHeaderSticky()
});
$(window).scroll(function () {
  initHeaderSticky()
});
$(document).ready(function () {
  // /********* On scroll heder Sticky *********/
  var prevScrollpos = window.pageYOffset;
  window.onscroll = function () {
    var currentScrollPos = window.pageYOffset;
    if (prevScrollpos > currentScrollPos) {
      document.getElementById("header-sticky").style.top = "0";
    } else {
      document.getElementById("header-sticky").style.top = "-100px";
    }
    prevScrollpos = currentScrollPos;
  }
});
  /********* layout js *********/
  $('.pro-theme-wrp').on('click', function (e) {
      $('body').addClass('no-scroll');
      $('.layout-section').addClass('open');
    });
    $('.demo-close').on('click', function (e) {
      e.preventDefault();
      $('body').removeClass('no-scroll');
      $('.layout-section').removeClass('open');
    });
  /********* Mobile Menu ********/
  $('.mobile-menu-button').on('click', function (e) {
    e.preventDefault();
    setTimeout(function () {
      $('body').addClass('no-scroll active-menu');
      $(".mobile-menu-wrapper").toggleClass("active-menu");
      $('.overlay').addClass('menu-overlay');
    }, 50);
  });

  $('body').on('click', '.overlay.menu-overlay, .menu-close-icon svg', function (e) {
    e.preventDefault();
    $('body').removeClass('no-scroll active-menu');
    $(".mobile-menu-wrapper").removeClass("active-menu");
    $('.overlay').removeClass('menu-overlay');
  });
  
   // custom reviews on product page
  $(window).on('load', function() {
    $(".pdp-right-column").find(".jdgm-prev-badge").append("<a class='product-write-review d-flex align-items-center'><svg xmlns='http://www.w3.org/2000/svg' fill='#000000' id='Outline' viewBox='0 0 24 24' width='16' height='16'><path d='M22.853,1.148a3.626,3.626,0,0,0-5.124,0L1.465,17.412A4.968,4.968,0,0,0,0,20.947V23a1,1,0,0,0,1,1H3.053a4.966,4.966,0,0,0,3.535-1.464L22.853,6.271A3.626,3.626,0,0,0,22.853,1.148ZM5.174,21.122A3.022,3.022,0,0,1,3.053,22H2V20.947a2.98,2.98,0,0,1,.879-2.121L15.222,6.483l2.3,2.3ZM21.438,4.857,18.932,7.364l-2.3-2.295,2.507-2.507a1.623,1.623,0,1,1,2.295,2.3Z'></path></svg> Write a Review</a>");
  }); 

   setTimeout(function() {
    $('.pdp-right-column .jdgm-prev-badge').on('click', function() {
       $('.pdp-tab-inner').find('.review_tab').addClass('active');
        if($('li.review_tab').hasClass('active')){
          $('li[data-tab="pdp-tab-1"], li[data-tab="pdp-tab-2"]').removeClass('active');
        }
      if($('.tab-content.review_tab').hasClass('active')){
          $('#pdp-tab-1, #pdp-tab-2').removeClass('active');
        }
    });
  }, 1000); 

   // product slider zoom
    $('.product-item-img.zoom').each(function() {
      $(this).zoom({
        url: false,
        callback: false,
        target: false,
        duration: 120,
        on: 'mouseover', // other options: grab, click, toggle
        touch: true, // enables a touch fallback
        onZoomIn: false,
        onZoomOut: false,
        magnify: 2
      });
    });
  
  /********* Announcebar hide ********/
  $('#announceclose').click(function () {
    $('.announcebar').slideUp("slow");
  });

   /********* Mobile Filter Popup ********/
 $('.mobile-facets__open').on('click', function (e) {
      $('body').addClass('mobile-open no-scroll');
      $('.overlay').addClass('active');
    });
    $('.overlay,.close-filter,.apply-btn').on('click', function (e) {
      $('body').removeClass('mobile-open no-scroll');
      $('.overlay').removeClass('active');
    });  
      var $this = $('.collection');
    if ($this.hasClass("canvas-leftbar")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
    var $this = $('.collection');
    if ($this.hasClass("canvas-rightbar")) {
      $('.filter-title').on('click', function (e) {
        $('body').addClass('no-scroll filter-open');
        $('.overlay').addClass('active');
      });
      $('.overlay,.close-filter').on('click', function (e) {
        $('body').removeClass('no-scroll filter-open');
        $('.overlay').removeClass('active');
      }); 
    }
 /*********  Header Search Popup  ********/
    $(".search-header a").click(function () {
    $(".search-eveland").addClass("active");
    $("body").addClass("no-scroll search");
    $('.overlay').addClass('active');
  });
  $(".overlay,.close-search").click(function () {    
    $(".search-eveland").removeClass("active");
    $("body").removeClass("no-scroll search");
    $('.overlay').removeClass('active');
 });

  /*********  ask qustion Popup  ********/
 $(".pro-features li a.ask-qus").click(function () {
    $(".ask-qus-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-btn").click(function () {
    $(".ask-qus-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  /********* mobile stickybar ********/
  $(window).scroll(function() {
    if ($(window).scrollTop() > 300) {
      $(".mobile-stickybar").addClass('show');
    } else {
      $(".mobile-stickybar").removeClass('show');
    }
  });
  /*********  delivery-popup ********/
   $(".pro-features li a.del-qus").click(function () {
    $(".delivery-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  $(".close-btn").click(function () {
    $(".delivery-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  /********* Cart Popup ********/
   if ($('body').hasClass('cart')) {
        // Disable click on the cart-header div
        $('.cart-header').on('click', function(event) {
            event.preventDefault();
            return false;
        });
    }else{

    $('.cart-header').on('click', function (e) {
    e.preventDefault();
      $('body').addClass('no-scroll cartOpen');
      $('.overlay').addClass('cart-overlay');
  });
    
  }
  
  $('body').on('click', '.overlay.cart-overlay, .closecart', function (e) {
    e.preventDefault();
    $('.overlay').removeClass('cart-overlay');
    $('body').removeClass('no-scroll cartOpen');
    $('.coupon-popup').removeClass('active');
    $('.gift-popup').removeClass('active');
  });
  
  /*********coupon popup ********/
  $(document).on('click', '.coupon-icon', function () {
      $(".coupon-popup").toggleClass("active");
    });
     $(document).on('click', '.coupon-icon', function () {
      $(".gift-popup").removeClass("active");
    });
    $(document).on('click', '.close-coupon', function () {
      $(".coupon-popup").removeClass("active");
    });
  
  // notify me
  $('body').on('click','.notify-btn', function(e) {
      e.preventDefault();
      $('body').addClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').addClass('active');
    });
   $('body').on('click','.overlay,.notify-popup-close', function(e) {
      e.preventDefault();
     $('body').removeClass('no-scroll notify-active');
      $('.out-of-stock-form,.overlay').removeClass('active');
    });
  /*********gift popup ********/
    $(document).on('click', '.gift-icon', function () {
      $(".gift-popup").toggleClass("active");
    });
     $(document).on('click', '.gift-icon', function () {
      $(".coupon-popup").removeClass("active");
    });
    $(document).on('click', '.close-gift', function () {
      $(".gift-popup").removeClass("active");
    });
    
  /*********  Size Popup  ********/
  $(".size-btn").click(function () {
    $(".size-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });

  $(".close-search").click(function () {
    $(".size-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  $(".close-btn").click(function () {
    $(".size-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });

  /******* Subscribe popup Js *******/
  $('.close-sub-btn').click(function () {
    $('.subscribe-popup').slideUp();
    $(".subscribe-overlay").removeClass("open");
  });
  
   /******* Cookie Js *******/
   $('.cookie-accept-btn').click(function () {
    $('.cookie-popup').slideUp();
  });

/****  TAB Js ****/
    $("ul.tabs li").click(function () {
        var $this = $(this);
        var $theTab = $(this).attr("data-tab");
        if ($this.hasClass("active")) {
        } else {
            $this
                .closest(".tabs-wrapper")
                .find("ul.tabs li, .tabs-container .tab-content")
                .removeClass("active");
            $(
                '.tabs-container .tab-content[id="' +
                $theTab +
                '"], ul.tabs li[data-tab="' +
                $theTab +
                "]"
            ).addClass("active");
        }
        $(this).addClass("active");
    });
  //*********  PRODUCT page  CART popup  **********/
  if($('body').hasClass('product')){
  $.fn.isInViewport = function() {
      var elementTop = this.offset().top;
      var elementBottom = elementTop + this.outerHeight();
      var viewportTop = $(window).scrollTop();
      var viewportBottom = viewportTop + $(window).height();
      return elementBottom > viewportTop && elementTop < viewportBottom;
  };
    $(window).scroll(function() {
        if ($('.cart-btn.product-button').isInViewport()) {
          $('.products-add-cart-sticky').removeClass('show-btn');
        } else {
          $('.products-add-cart-sticky').addClass('show-btn');
        }
    });
    }

$('body').on('click','.products-add-cart-sticky .sticky-btn', function(e) {
    e.preventDefault();
    var $this = $(this);
    $this.find('.loading-overlay__spinner').removeClass('hidden');
    $this.addClass('loading');

    // Trigger the click event after a slight delay
    setTimeout(function() {
        $('.cart-btn.product-button').trigger("click");

        // Wait for a short time before removing the loading class and adding the hidden class
        setTimeout(function() {
            $this.find('.loading-overlay__spinner').addClass('hidden');
            $this.removeClass('loading');
        }, 500); // Adjust the delay time as needed
    }, 500); // Adjust the delay time as needed
});


  $('body').on('click','.products-add-cart-sticky .button', function() {
      $(this).closest('.radio-buttons').find('label.sticky-active').removeClass('sticky-active');
      $(this).find("label").addClass("sticky-active");
  });
  
  // currency-nice-select
$('body').on('click', '.country-name .nice-select', function (e) {
  e.stopPropagation(); // Stop the event from propagating to the body
  $(this).toggleClass('open');
});
$('body').on('click', function (e) {
  $('.country-name .nice-select').removeClass('open');
});

function currencyFormSubmit(event) {
  event.target.form.submit();
}

document.querySelectorAll('.country-name .nice-select .list li').forEach(function (currencyItem) {
  currencyItem.addEventListener('click', function () {
    // Trigger change event on the associated select element
    var selectElement = this.closest('.country-name').querySelector('select');
    if (selectElement) {
      // Set the selected option based on the data-currency attribute of the clicked li
      selectElement.value = this.dataset.currency;
      
      // Trigger change event
      var event = new Event('change', { bubbles: true });
      selectElement.dispatchEvent(event);

      // Submit the form
      currencyFormSubmit({ target: selectElement });
    }
  });
});
  
      /*********  Multi-level accordion nav  ********/
  $('.acnav-label').click(function () {
    var label = $(this);
    var parent = label.parent('.has-children');
    var list = label.siblings('.acnav-list');
    if (parent.hasClass('is-open')) {
      list.slideUp('fast');
      parent.removeClass('is-open');
    }
    else {
      list.slideDown('fast');
      parent.addClass('is-open');
    }
  });
    /*** home banner slider **/
        var swiper = new Swiper(".home-banner-slider", {
        speed: 800,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        navigation: {
            nextEl: ".home-arrow-next",
            prevEl: ".home-arrow-prev",
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
        },
    });

   /** Trending Products slider **/
    var swiper = new Swiper(".trending-product-slider", {
        spaceBetween: 20,
        loop: false,
        slidesPerColumn: 2,
        slidesPerView: 4,
        speed: 800,
        grid: {
            rows: 2,
        },
        navigation: {
            nextEl: ".trending-product.swiper-button-next",
            prevEl: ".trending-product.swiper-button-prev",
        },
        breakpoints: {
            1200: {
                slidesPerView: 4,
                grid: {
                    rows: 2,
                },
            },
            1024: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                },
            },
            768: {
                slidesPerView: 3,
                grid: {
                    rows: 2,
                },
            },
            575: {
                slidesPerView: 2,
                grid: {
                    rows: 2,
                },
            },
            320: {
                slidesPerView: 1,
                grid: {
                    rows: 2,
                },
            },
            0: {
                slidesPerView: 1,
                grid: {
                    rows: 2,
                },
            },
        },
    });

  /** premiun product slider **/
    var swiper = new Swiper(".premium-product-slider", {
    slidesPerView:4,
    loop: true,
    speed: 800,
    spaceBetween: 15,
    navigation: {
      nextEl: ".premium-card-slider.swiper-button-next",
      prevEl: ".premium-card-slider.swiper-button-prev",
  },
    breakpoints: {
        992: {
        slidesPerView: 4,
        },
        768: {
        slidesPerView: 3,
        },
        576: {
        slidesPerView: 2,
        },
        476: {
        slidesPerView: 1,
        },
        0: {
        slidesPerView: 1,
        },
    },
    });

  /*** testimonial slider **/
     var swiper = new Swiper(".testimonial-slider", {
        speed: 800,
        loop: true,
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
            320: {
                slidesPerView: 1,
            },
        },
    });

   /** home blog slider **/
    var swiper = new Swiper(".home-blog-slider", {
    slidesPerView: 3,
    spaceBetween: 20,
    loop: true,
    slidesPerColumn: 2,
    speed: 800,
    navigation: {
        nextEl: ".blog-slider.swiper-button-next",
        prevEl: ".blog-slider.swiper-button-prev",
    },
    breakpoints: {
        992: {
        slidesPerView: 3,
        },
        768: {
        slidesPerView: 2,
        },
        576: {
        slidesPerView: 2,
        },
        0: {
        slidesPerView: 1,
        },
    },
    });
/** blog page slider **/
var swiper = new Swiper(".elegant-product-slider", {
  slidesPerView: 1,
  spaceBetween: 20,
  loop: true,
  autoplay: true,
  speed: 800,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
  },
});

   /** About Product slider **/
  var swiper = new Swiper(".about-product-sec .about-product-slider", {
    loop: true,
    slidesPerView: 5,
    // autoplay:true,
    centeredSlides: true,
    speed: 800,
    breakpoints: {
      1600: {
        slidesPerView: 5,
        spaceBetween: 0,
      },
      1200: {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 0,
      },
      1024: {
        slidesPerView: 4,
        centeredSlides: false,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 15,
      },
      575: {
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 15,
      },
      320: {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1,
        centeredSlides: false,
        spaceBetween: 15,
      },
    },
  });

    /** client logo slider **/
    var swiper = new Swiper(".client-logo-slider", {
    slidesPerView: 7,
    spaceBetween: 20,
    loop: true,
    speed: 800,
    autoplay:true,
    breakpoints: {
        1200: {
        slidesPerView: 5,
        },
        992: {
        slidesPerView: 4,
        },
        768: {
        slidesPerView: 3,
        },
        576: {
        slidesPerView: 2,
        },
        476: {
        slidesPerView: 2,
        },
        0: {
        slidesPerView: 1,
        },
    },
    });
  /** Team slider **/
   var swiper = new Swiper(".about-team-slider", {
    slidesPerView: 4,
    loop: true,
    speed: 800,
    spaceBetween: 0,
    // autoplay:true,
    breakpoints: {
      1200: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      476: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
  
 /** About Page service slider **/
  var swiper = new Swiper(".about-service-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    autoplay:true,
    navigation: {
      nextEl: ".about-service-slider.swiper-button-next",
      prevEl: ".about-service-slider.swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
      },  
      575: {
        slidesPerView: 1,
      },  
      0: {
        slidesPerView: 1, 
      },  
    },
  });
  /******* Subscribe popup Js *******/
  $('.close-sub-btn').click(function () {
    $('.subscribe-popup').slideUp();
    $(".subscribe-overlay").removeClass("open");
  });

/**** product page slider *****/
  var bottomgalleryThumbs = new Swiper(".bottom-thumbslider", {
    centeredSlides: false,
    centeredSlidesBounds: true,
    slidesPerView: 4,
    spaceBetween: 10,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      1200:{
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 15,
      },
      576: {
        slidesPerView: 4,
      },
      320: {
        slidesPerView: 3,
      },
      0: {
        slidesPerView: 3,
      },
    },
  });

  var bottomgalleryMain = new Swiper(".bottom-main-slider", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: bottomgalleryThumbs
    }
  });

   bottomgalleryMain.on('slideChangeTransitionStart', function() {
    bottomgalleryThumbs.slideTo(bottomgalleryMain.activeIndex);
  });

  bottomgalleryThumbs.on('transitionStart', function(){
    bottomgalleryMain.slideTo(bottomgalleryThumbs.activeIndex);
  });
  

  /** product page slider **/
var galleryThumbs = new Swiper(".grid-gallery-main", {
  centeredSlides: false,
  centeredSlidesBounds: true,
  slidesPerView: 1,
  spaceBetween: 15,
  watchOverflow: true,
  loop: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  watchSlidesVisibility: true,
  watchSlidesProgress: true,

});

  $(document).on('click', '.grid-gall-thumb img', function () {
    var grid_thumb = $(this).attr('data-img');
    var gridImageIndex = $('.grid-gallery-main .product-item-img img[data-img="'+grid_thumb+'"]').parents('.swiper-slide').index();
    new Swiper('.grid-gallery-main').slideTo(gridImageIndex);
  });
  

  if ($('.gallery-main').hasClass('two-grid-main') || $('.gallery-main').hasClass('one-grid-main')){
  var swiper = null;
  var isSwiperInitialized = false;
  }
  function initSwiper() {
      /**** product two grid page slider *****/
 if ($('.gallery-main').hasClass('two-grid-main')){
   swiper = new Swiper(".two-grid-main", {
    slidesPerView: 1,
    spaceBetween: 10,
    freeMode: false,
    simulateTouch:false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      420: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      575: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: false,
        simulateTouch:false, 
      },
    },
  });
 }
  /**** product one grid page slider *****/
 if ($('.gallery-main').hasClass('one-grid-main')){
    swiper = new Swiper(".one-grid-main", {
    slidesPerView: 1,
    spaceBetween: 10,
    freeMode: false,
    simulateTouch:false,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      420: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      575: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: "auto",
        spaceBetween: 0,
        freeMode: false,
        simulateTouch:false, 
      },
    },
  });
 }   
    
 }  // initswiper

if ($('.swiper').hasClass('two-grid-main') || $('.gallery-main').hasClass('one-grid-main')) {
  function destroySwiper() {
  if (swiper !== null) {
    swiper.destroy();
    swiper = null;
  }
}
function handleSwiper() {
  if (jQuery(window).width() < 768) {
    if (!isSwiperInitialized) {
      initSwiper();
      isSwiperInitialized = true;
    }
  } else {
    if (isSwiperInitialized) {
      destroySwiper();
      isSwiperInitialized = false;
    }
  }
}
// Function to handle resizing
function handleResize() {
  $(window).resize(function () {
    handleSwiper();
  }).trigger('resize'); // Trigger resize event on page load
}
// Call handleResize function on page load
$(document).ready(function () {
  handleResize();
});

  
  handleSwiper();
  }

  
   /**** product no thumb page slider *****/
   var swiper = new Swiper(".no-thumb-slider", {
    slidesPerView: 1,
    spaceBetween: 20,
    speed: 800,
    loop:true,
    // autoplay:true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      992: {
        slidesPerView: 1,
      },
      768: {
        slidesPerView: 1,
      },
      576: {
        slidesPerView: 1,
      },  
      575: {
        slidesPerView: 1,
      },  
      0: {
        slidesPerView: 1,
      },  
    },
  });


  /****** product thumb left page slider *****/
  var leftgalleryThumbs = new Swiper(".left-thumbslider", {
    centeredSlides: false,
    centeredSlidesBounds: true,
    slidesPerView: 5,
    spaceBetween: 10,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: "vertical",
    breakpoints: {
      1200:{
        slidesPerView: 4,
      },
      992:{
        slidesPerView: 4,
        direction: "vertical",
      },
      768: {
        direction: 'horizontal', 
        slidesPerView: 3,
        spaceBetween: 15,
      },
      576: {
        direction: 'horizontal', 
        slidesPerView: 4,
      },
      320: {
        direction: 'horizontal',
        slidesPerView: 3,
      },
      0: {
        direction: 'horizontal',
        slidesPerView: 3,
      },
    },
  });

  var leftgalleryMain = new Swiper(".left-mainslider", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: leftgalleryThumbs
    }
  });

  leftgalleryMain.on('slideChangeTransitionStart', function() {
    leftgalleryThumbs.slideTo(leftgalleryMain.activeIndex);
  });

  leftgalleryThumbs.on('transitionStart', function(){
    leftgalleryMain.slideTo(leftgalleryThumbs.activeIndex);
  });
  
   /****** product thumb right page slider *****/
   var rightgalleryThumbs = new Swiper(".right-thumbslider", {
    centeredSlides: false,
    centeredSlidesBounds: true,
    slidesPerView: 5,
    spaceBetween: 10,
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    direction: "vertical",
    breakpoints: {
      1200:{
        slidesPerView: 4,
      },
      992:{
        slidesPerView: 4,
        direction: "vertical",
      },
      768: {
        direction: 'horizontal', 
        slidesPerView: 3,
        spaceBetween: 15,
      },
      576: {
        direction: 'horizontal', 
        slidesPerView: 4,
      },
      320: {
        direction: 'horizontal',
        slidesPerView: 3,
      },
      0: {
        direction: 'horizontal',
        slidesPerView: 3,
      },
    },
  });

  var rightgalleryMain = new Swiper(".right-mainslider", {
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    preventInteractionOnTransition: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: rightgalleryThumbs
    }
  });

  rightgalleryMain.on('slideChangeTransitionStart', function() {
    rightgalleryThumbs.slideTo(rightgalleryMain.activeIndex);
  });

  rightgalleryThumbs.on('transitionStart', function(){
    rightgalleryMain.slideTo(rightgalleryThumbs.activeIndex);
  });
     
  /*******  {PRODUCT PAGE} Feature Product Slider *******/
  var swiper = new Swiper(".product-feature-slider", {
    spaceBetween: 15,
    loop: true,
    speed: 800,
    grid: {
      rows: 1,
    },
    slidesPerView: 4,
    slidesPerColumn: 2,
    breakpoints: {
      1100: {
        slidesPerView: 4,
      },
      991: {
        slidesPerView: 3,
 
      },
      768: {
        slidesPerView: 2,
      },
      575: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });

  /** Product Offer slider **/
  var swiper = new Swiper(".product-offer-slider", {
    spaceBetween: 15,
    loop: true,
    slidesPerView: 4,
    speed: 800,
    navigation: {
      nextEl: ".product-offer.swiper-button-next",
      prevEl: ".product-offer.swiper-button-prev",
    },
    breakpoints: { 
      1200: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 3,
      },
      575: {
        slidesPerView: 2,
      },
      320: {
        slidesPerView: 1,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
  
    /** client logo slider **/
  var swiper = new Swiper(".about-team-slider", {
    slidesPerView: 4,
    loop: true,
    speed: 800,
    spaceBetween: 0,
    // autoplay:true,
    breakpoints: {
      1200: {
        slidesPerView: 4,
        spaceBetween: 0,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 0,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 15,
      },
      476: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      0: {
        slidesPerView: 1,
      },
    },
  });
    // *** video-play *** //
    $('.play-video').on('click',function(){
        if($(this).attr('data-click') == 1) {
        $(this).attr('data-click', 0)
        $('#img-video')[0].pause();
        $(".play-video").css("opacity", "1");
        } else {
        $(this).attr('data-click', 1)
        $('#img-video')[0].play();
        $(".play-video").css("opacity", "1");
        $(".play-video").css("opacity", "0");
        }
    });

    /** counter js **/
  $('.counting').each(function () {
    var $this = $(this),
      countTo = $this.attr('data-count');

    $({ countNum: $this.text() }).animate({
      countNum: countTo
    },

      {
        duration: 3000,
        easing: 'linear',
        step: function () {
          $this.text(Math.floor(this.countNum));
        },
        complete: function () {
          $this.text(this.countNum);
        }

      });
  });
  
    /******* quick-view-popup Js *******/

  $(".quick-close-btn").click(function () {
    $(".quick-view-popup").removeClass("active");
    $("body").removeClass("no-scroll");
  });
  $('body').on('click', '.quickview-btn', function(e) {
    e.preventDefault();
    var href= '/products/'+$(this).data('handle')+'?view=qv';
    $.get(href, function(product) {
      $('.quickview_popup_data').html(product);
    var swiper = new Swiper(".quickview-img-slider", {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: false,
        speed: 800,
        navigation: {
            nextEl: ".quickview-next-btn.swiper-button-next",
            prevEl: ".quickview-prev-btn.swiper-button-prev",
        },
        breakpoints: {
            992: {
                slidesPerView: 1,
            },
            0: {
                slidesPerView: 1,
            }
        },
    });    
    });
    $(".quick-view-popup").toggleClass("active");
    $("body").toggleClass("no-scroll");
  });
  
$('body').on('click', '.quickview_popup_data .radio-buttons .button', function() {
  var selectedValues = [];

  // Collect selected option values
  $('.quickview_popup_data .radio-buttons .button input:checked').each(function() {
    var selectedValue = $(this).val();
    
    if (selectedValue) {
      selectedValues.push(selectedValue);
    }
  });
var joinedValues = selectedValues.join(' / ');

  $('.variant-qv').each(function() {
    var variant_title = $(this).data('title');
    var variant_img = $('.variant-qv[data-title="'+variant_title+'"]').data('img');
    var variant_price = $('.variant-qv[data-title="'+variant_title+'"]').data('price');
    var qv_btn =  $('.variant-qv[data-title="'+variant_title+'"]').data('avail');
    var variant_id = $('.variant-qv[data-title="'+variant_title+'"]').data('id');

    // Convert variant_title to a string to ensure type consistency
    variant_title = String(variant_title);
    // Check if variant_title exists in the selectedValues array
    if(variant_title === joinedValues){
      var variantImageIndex = $('.quickview-img-slider .quickview-card-image img[data-img="'+variant_img+'"]').parents('.qv-pro-slider-img').index();
      new Swiper('.quickview-img-slider').slideTo(variantImageIndex);

      $('.qv-price').find('.price-item--regular').text(variant_price);

      if (qv_btn === true) {
        $('.quickview_popup_data .product-form__submit').find('span').text('Add To Cart');
        $('.quickview_popup_data .product-form__submit').removeAttr('disabled');
        $('.quickview_popup_data .quantity-select').show();
         $('.quickview_popup_data .qty-labal').show();
        
      } else {
        $('.quickview_popup_data .product-form__submit').find('span').text('Sold out');
        $('.quickview_popup_data .product-form__submit').attr('disabled', 'disabled');
        $('.quickview_popup_data .quantity-select').hide();
         $('.quickview_popup_data .qty-labal').hide();
      }

      $('input[name="id"]').val(variant_id);
    }
  });
});
/******* quick-view-popup end *******/

  
  /** footer acnav **/
  $('.acnav-label1').click(function (event) {
    event.preventDefault();
    if (jQuery(window).width() < 768) {
      var label = $(this);
      var parent = label.parent('.has-children1');
      var list = label.siblings('.acnav-list1');
      if (parent.hasClass('is-open')) {
        list.slideUp('fast');
        parent.removeClass('is-open');
      }
      else {
        list.slideDown('fast');
        parent.addClass('is-open');
      }
    }
  });
});

      /** counter js **/
  $('.counting').each(function () {
    var $this = $(this),
      countTo = $this.attr('data-count');

    $({ countNum: $this.text() }).animate({
      countNum: countTo
    },

      {
        duration: 3000,
        easing: 'linear',
        step: function () {
          $this.text(Math.floor(this.countNum));
        },
        complete: function () {
          $this.text(this.countNum);
        }

      });
  });
  /** List Category slider **/
  var swiper = new Swiper(".list-category-slider", {
    spaceBetween: 15,
    slidesPerView: 4,
    speed: 800,
    breakpoints: {
      1400: {
        slidesPerView: 5,
      },
      1200: {
        slidesPerView: 5,
        loop: true,
      },
      991: {
        slidesPerView: 4,
        loop: true,
      },
      768: {
        slidesPerView: 3,
        loop: true,
      },
      575: {
        slidesPerView: 2,
        loop: true,
      },
      320: {
        slidesPerView: 1,
        loop: true,
      },
      0: {
        slidesPerView: 1,
        loop: true,
      },
    },
  });
 /********* category product style-1 ********/
  // 1.list view
  
    $(".list-view").click(function () {
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");
      $(".two-grid-view").removeClass("active");

      $(".grid-product .row").removeClass("product-grid-view");
      $(".grid-product .row").removeClass("flex-slider");
      $(".grid-product .row").addClass("product-list-view");

        // common list
        jQuery('.product-list-view > .grid__item').each(function() {

        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);;

        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').prependTo(prod_btn);

        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-card-image .time-counter ').appendTo(coll_count);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);

        var prod_rat = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_rat);
          
        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.price').insertAfter(prod_form);

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);
          
         var prod_lable = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.label-sale').prependTo(prod_lable);

      });

      
      // style1

      jQuery('.product-list-view > .product-card-one').each(function() {

         var qv_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.qv-btn').appendTo(qv_btn);
        
      });

      // style3

      jQuery('.product-list-view > .product-card-three').each(function() {

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.cart-btn-main').appendTo(prod_form);

      });

        // style4

      jQuery('.product-list-view > .product-card-four').each(function() {

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.pro-btn').prependTo(prod_btn);

      });
      
    });

  // 2.grid view
    $(".grid-view").click(function () {
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");
      $(".two-grid-view").removeClass("active");

      $(".grid-product .row").addClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");
      $(".grid-product .row").removeClass("flex-slider");

      // common list
      jQuery('.product-grid-view > .grid__item').each(function() {

        var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_lable);
        
        var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);
        
      });
      
      // style-1
        jQuery('.product-grid-view > .product-card-one').each(function() {
                
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

           var prod_count = jQuery(this).find('.cart-btn-content');
        jQuery(this).find('.time-counter').insertAfter(prod_count);
        
        var qv_btn = jQuery(this).find('.cart-btn-content');
        jQuery(this).find('.qv-btn').appendTo(qv_btn);

        var prod_add = jQuery(this).find('.qv-btn');
        jQuery(this).find('.product-form').insertAfter(prod_add);

        var prod_add = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_add);

      });

      // style-2
      jQuery('.product-grid-view > .product-card-two').each(function() {
                
       var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

         var prod_labl = jQuery(this).find('.time-counter');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_labl);

        var prod_rat = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rat);
        
        var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.price ').insertAfter(div_right);

         var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.product-content-top p ').insertAfter(div_right);

        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').prependTo(prod_btn);

        var prod_sel = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_sel);

      });

      // style-3
      jQuery('.product-grid-view > .product-card-three').each(function() {
                
       var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.cart-btn-main').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.label-sale').insertAfter(prod_btn);

        var label_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.pro-label').appendTo(label_btn);

        var timer_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.time-counter').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(rat_btn);

      });

      // style4

      jQuery('.product-grid-view > .product-card-four').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn);

        var timer_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(timer_btn);

        var timer_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.price').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.price');
        jQuery(this).find('.rating-wrapper').insertAfter(rat_btn);

         var rat_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.color-swatch-variants').insertAfter(rat_btn);

          var rat_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-wish').prependTo(rat_btn);

         var rat_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-compare').insertAfter(rat_btn);

      });

        // style5

      jQuery('.product-grid-view > .product-card-five').each(function() {

         var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_lable);
        
          var prod_lable = jQuery(this).find('.pro-btn-wrapper');
         jQuery(this).find('.time-counter').insertAfter(prod_lable);

         var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.product-details').insertAfter(prod_btn);
        
        var prod_btn = jQuery(this).find('.product-details');
        jQuery(this).find('.price').prependTo(prod_btn);

          var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

      });

       // style6

        jQuery('.product-grid-view > .product-card-six').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);

        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);

         var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
          
      });
      
      // style7

        jQuery('.product-grid-view > .product-card-seven').each(function() {

       var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);

        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);

         var prod_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_btn);
          
      });

      // style8

        jQuery('.product-grid-view > .product-card-eight').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertBefore(prod_btn2);

        var prod_cart = jQuery(this).find('.product-content-top');
        jQuery(this).find('.add-to-cart').prependTo(prod_cart);

         var prod_btn = jQuery(this).find('.add-to-cart');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);
          
          
      });

      // style-9

        jQuery('.product-grid-view > .product-card-nine').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);
          
        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-form').prependTo(prod_btn);
        
      });

       // style-10

        jQuery('.product-grid-view > .product-card-ten').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.rating-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.time-counter').insertAfter(prod_btn);

        var prod_label = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.pro-btn-wrapper').insertBefore(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.color-swatch-variants').prependTo(prod_btn2); 
          
        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-form');
        jQuery(this).find('.price').insertBefore(prod_btn2); 
          
      });
      
    });

  // 3.two grid view
      $(".two-grid-view").click(function () {
      $(".two-grid-view").addClass("active");
      $(".grid-view").removeClass("active");
      $(".list-view").removeClass("active");

      $(".grid-product .row").removeClass("product-grid-view");
      $(".grid-product .row").removeClass("product-list-view");
      $(".grid-product .row").addClass("flex-slider");

      // common list
      jQuery('.flex-slider > .grid__item').each(function() {

        var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_lable);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
           var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);
        
      });

      // style-1
     jQuery('.flex-slider > .product-card-one').each(function() {
                
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
       
        var prod_count = jQuery(this).find('.cart-btn-content');
        jQuery(this).find('.time-counter').insertAfter(prod_count);
        
        var qv_btn = jQuery(this).find('.cart-btn-content');
        jQuery(this).find('.qv-btn').appendTo(qv_btn);

        var prod_add = jQuery(this).find('.qv-btn');
        jQuery(this).find('.product-form').insertAfter(prod_add);

        var prod_add = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_add);

      });

      // style-2
      jQuery('.flex-slider > .product-card-two').each(function() {
                
       var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

         var prod_labl = jQuery(this).find('.time-counter');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_labl);

        var prod_rat = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rat);

        var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.price ').insertAfter(div_right);
        
        var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.product-content-top p ').insertAfter(div_right);

        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').prependTo(prod_btn);

         var prod_sel = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_sel);
        
      });

      // style-3
      jQuery('.flex-slider > .product-card-three').each(function() {
                
         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.cart-btn-main').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.label-sale').insertAfter(prod_btn);

        var label_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.pro-label').appendTo(label_btn);

        var timer_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.time-counter').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(rat_btn);

      });
        // style4

      jQuery('.flex-slider > .product-card-four').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn);

        var timer_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(timer_btn);

        var timer_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.price').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.price');
        jQuery(this).find('.rating-wrapper').insertAfter(rat_btn);

         var rat_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.color-swatch-variants').insertAfter(rat_btn);

          var rat_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-wish').prependTo(rat_btn);

         var rat_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-compare').insertAfter(rat_btn);

      });

        // style5

      jQuery('.flex-slider > .product-card-five').each(function() {

         var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_lable);
        
          var prod_lable = jQuery(this).find('.pro-btn-wrapper');
         jQuery(this).find('.time-counter').insertAfter(prod_lable);

         var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.product-details').insertAfter(prod_btn);
        
        var prod_btn = jQuery(this).find('.product-details');
        jQuery(this).find('.price').prependTo(prod_btn);

          var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

      });

       // style6

        jQuery('.flex-slider > .product-card-six').each(function() {
  
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);
  
        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);
  
        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);
  
        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);
  
         var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
      });

        // style7

        jQuery('.flex-slider > .product-card-seven').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);

        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);

         var prod_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_btn);
          
      });

      // style8

        jQuery('.flex-slider > .product-card-eight').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertBefore(prod_btn2);

        var prod_cart = jQuery(this).find('.product-content-top');
        jQuery(this).find('.add-to-cart').prependTo(prod_cart);

         var prod_btn = jQuery(this).find('.add-to-cart');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);
          
      });

         // style9

        jQuery('.flex-slider > .product-card-nine').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);

          var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-form').prependTo(prod_btn);
          
      });

          // style-10

        jQuery('.flex-slider > .product-card-ten').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.rating-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.time-counter').insertAfter(prod_btn);

        var prod_label = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.pro-btn-wrapper').insertBefore(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.color-swatch-variants').prependTo(prod_btn2); 
          
        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-form');
        jQuery(this).find('.price').insertBefore(prod_btn2); 
          
      });
        
    });

function responsiveMenu(){
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }
  if(jQuery(window).width() < 768) {
    $('.product-filter-column').prependTo('.product-heading-row .container .row .product-heading-column');
  }
  else { 
    $('.product-filter-column').prependTo('.product-list-row');
  }
}
jQuery(document).ready(function() {
  responsiveMenu();
});
jQuery(window).resize(function() {
  responsiveMenu();
});
// load-more button scroll
if ($('.load-more_wrap').hasClass('load-more-btn')){
  function loadMoreProducts(nextUrl, totalPages) {
  var $this = $('.js-load-more'),
      currentPage = parseInt($('[data-this-page]').val());
  var data_winurl = window.location.href.split('/collections');
  var final_data_url = data_winurl[1];
  var finalURL = "/collections" + final_data_url;
  
  $this.attr('disabled', true);
  $this.addClass('hide');
  $this.siblings('[loader]').removeClass('hide');
  
  var current_page_new = currentPage + 1;
  var next_coll = currentPage + 2;

  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      if (finalURL.includes('filter.')) {
        $('[data-next-link]').val(finalURL + "&page=" + next_coll);
       }else{
         $('[data-next-link]').val(finalURL + "?page=" + next_coll);
       }
      $('[data-this-page]').val(current_page_new);
      
      // Replace the following line with the appropriate selector for your HTML structure
      $('.product-grid-view, .product-list-view, .flex-slider').append($(responseHTML).find('.product-grid-view, .product-list-view, .flex-slider').html());
      
      countDownIni('.flip-countdown,.js-flip-countdown'); 

 // common list
        jQuery('.product-list-view > .grid__item').each(function() {

        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);;

        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').prependTo(prod_btn);

        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-card-image .time-counter ').appendTo(coll_count);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);

        var prod_rat = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_rat);
          
        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.price').insertAfter(prod_form);

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);
          
         var prod_lable = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.label-sale').prependTo(prod_lable);

      });

      
      // style1

      jQuery('.product-list-view > .product-card-one').each(function() {

         var qv_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.qv-btn').appendTo(qv_btn);
        
      });

      // style3

      jQuery('.product-list-view > .product-card-three').each(function() {

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.cart-btn-main').appendTo(prod_form);

      });

        // style4

      jQuery('.product-list-view > .product-card-four').each(function() {

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.pro-btn').prependTo(prod_btn);

      });
      // end list

       // common list
      jQuery('.flex-slider > .grid__item').each(function() {

        var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_lable);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
           var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);
        
      });

      // style-1
     jQuery('.flex-slider > .product-card-one').each(function() {
                
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var qv_btn = jQuery(this).find('.cart-btn-content');
        jQuery(this).find('.qv-btn').appendTo(qv_btn);

        var prod_add = jQuery(this).find('.qv-btn');
        jQuery(this).find('.product-form').insertAfter(prod_add);

        var prod_add = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_add);

      });

      // style-2
      jQuery('.flex-slider > .product-card-two').each(function() {
                
       var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

         var prod_labl = jQuery(this).find('.time-counter');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_labl);

        var prod_rat = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rat);

        var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.price ').insertAfter(div_right);
        
        var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.product-content-top p ').insertAfter(div_right);

        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').prependTo(prod_btn);

         var prod_sel = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_sel);
        
      });

      // style-3
      jQuery('.flex-slider > .product-card-three').each(function() {
                
         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.cart-btn-main').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.label-sale').insertAfter(prod_btn);

        var label_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.pro-label').appendTo(label_btn);

        var timer_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.time-counter').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(rat_btn);

      });
        // style4

      jQuery('.flex-slider > .product-card-four').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn);

        var timer_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(timer_btn);

        var timer_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.price').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.price');
        jQuery(this).find('.rating-wrapper').insertAfter(rat_btn);

         var rat_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.color-swatch-variants').insertAfter(rat_btn);

          var rat_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-wish').prependTo(rat_btn);

         var rat_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-compare').insertAfter(rat_btn);

      });

        // style5

      jQuery('.flex-slider > .product-card-five').each(function() {

         var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_lable);
        
          var prod_lable = jQuery(this).find('.pro-btn-wrapper');
         jQuery(this).find('.time-counter').insertAfter(prod_lable);

         var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.product-details').insertAfter(prod_btn);
        
        var prod_btn = jQuery(this).find('.product-details');
        jQuery(this).find('.price').prependTo(prod_btn);

          var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

      });

       // style6

        jQuery('.flex-slider > .product-card-six').each(function() {
  
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);
  
        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);
  
        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);
  
        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);
  
         var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
      });

        // style7

        jQuery('.flex-slider > .product-card-seven').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);

        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);

         var prod_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_btn);
          
      });

      // style8

        jQuery('.flex-slider > .product-card-eight').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertBefore(prod_btn2);

        var prod_cart = jQuery(this).find('.product-content-top');
        jQuery(this).find('.add-to-cart').prependTo(prod_cart);

         var prod_btn = jQuery(this).find('.add-to-cart');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);
          
      });

         // style9

        jQuery('.flex-slider > .product-card-nine').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);

          var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-form').prependTo(prod_btn);
          
      });

          // style-10

        jQuery('.flex-slider > .product-card-ten').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.rating-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.time-counter').insertAfter(prod_btn);

        var prod_label = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.pro-btn-wrapper').insertBefore(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.color-swatch-variants').prependTo(prod_btn2); 
          
        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-form');
        jQuery(this).find('.price').insertBefore(prod_btn2); 
          
      });
      // end two-grid
    },
    complete: function() {
      if (current_page_new < totalPages) {
        $this.attr('disabled', false);
        $this.removeClass('hide');
        $this.siblings('[loader]').addClass('hide');
      } else{
         $this.parents('.load-more_wrap').addClass('hide');
      }
    } 
  });
}    
 //   $(".menu-lnk.has-item").hover(function () {
 //    $('body').toggleClass("no-scroll");
 // });
  $('.js-load-more').on('click', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });

  $('.product-list-view').on('click', '.js-load-more', function() {
    var nextUrl = $('[data-next-link]').val();
    var totalPages = parseInt($('[data-all-pages]').val());
    loadMoreProducts(nextUrl, totalPages);
  });
}
// load-more button scroll end
//******** progress-wrap ************//
function scrollIndicator() {
  const scrollTop = document.documentElement.scrollTop;
  const scrollHeight = document.documentElement.scrollHeight;
  const windowHeight = document.documentElement.clientHeight;
  const maxScrollTop = scrollHeight - windowHeight;
  const scrollPointBottom = $('.scroll-line').outerHeight();
  const scrollPointPos = (scrollTop * scrollPointBottom) / maxScrollTop;

  if (scrollTop > 200) {
    $('.scroll-progress').addClass('visible');
  } else {
    $('.scroll-progress').removeClass('visible');
  }

  anime({
    targets: '.scroll-point',
    perspective: '500px',
    translateX: 0,
    translateY: scrollPointPos,
    translateZ: '0',
    easing: 'easeOutCirc'
  });
}

$(document).ready(function () {
  // Initial call on document ready
  scrollIndicator();

  // Attach scroll event listener
  $(document).scroll(function () {
    scrollIndicator();
  });
});

/********* Wrapper top space ********/

// infinit scroll
if ($('.load-more_wrap').hasClass('infinite-scroll')){
var infinitelastLoadedUrl = "";
  // Function to load more products
  function infiniteloadMoreProducts(nextUrl, totalPages) {
    if (nextUrl === infinitelastLoadedUrl) {
          return; // Exit function if nextUrl is repeated
      }
     infinitelastLoadedUrl = nextUrl;
      var currentPage = parseInt($('[data-this-page]').val());
      var data_winurl = window.location.href.split('/collections');
      var final_data_url = data_winurl[1];
      var finalURL = "/collections" + final_data_url;
  
      // Disable load more button and show loader
      $('[loader]').removeClass('hide');
  
      var current_page_new = currentPage + 1;
      var next_coll = currentPage + 2;
  
      $.ajax({
          url: nextUrl,
          type: 'GET',
          dataType: 'html',
          success: function(responseHTML) {
             if (finalURL.includes('filter.')) {
              $('[data-next-link]').val(finalURL + "&page=" + next_coll);
             }else{
               $('[data-next-link]').val(finalURL + "?page=" + next_coll);
             }
            $('[data-this-page]').val(current_page_new);
  
              // Append loaded products to the container
              $('.product-grid-view, .product-list-view, .flex-slider').append($(responseHTML).find('.product-grid-view, .product-list-view, .flex-slider').html());
  
              // Call any necessary initialization functions
              countDownIni('.flip-countdown,.js-flip-countdown');
             // start list
      // common list
        jQuery('.product-list-view > .grid__item').each(function() {

        var prod_img = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content-top').insertAfter(prod_img);;

        var prod_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(prod_right);
          
        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').prependTo(prod_btn);

        var coll_count = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-card-image .time-counter ').appendTo(coll_count);

        var prod_lable = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-label-wrp').prependTo(prod_lable);

        var prod_rev = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rev);

        var prod_rat = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_rat);
          
        var prod_form = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.price').insertAfter(prod_form);

        var prod_pri = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_pri);

        var prod_add = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_add);
          
         var prod_lable = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.label-sale').prependTo(prod_lable);

      });

      
      // style1

      jQuery('.product-list-view > .product-card-one').each(function() {

         var qv_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.qv-btn').appendTo(qv_btn);
        
      });

      // style3

      jQuery('.product-list-view > .product-card-three').each(function() {

        var prod_form = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.cart-btn-main').appendTo(prod_form);

      });

        // style4

      jQuery('.product-list-view > .product-card-four').each(function() {

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.pro-btn').prependTo(prod_btn);

      });
      // end list

       // common list
      jQuery('.flex-slider > .grid__item').each(function() {

        var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-label-wrp').appendTo(prod_lable);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
           var div_con = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-content').insertAfter(div_con);
        
        var div_left = jQuery(this).find('.product-content');
        jQuery(this).find('.product-content-top').prependTo(div_left);

        var div_right = jQuery(this).find('.product-content-top');
        jQuery(this).find('.product-content-bottom').insertAfter(div_right);
        
      });

       // style-1
     jQuery('.flex-slider > .product-card-one').each(function() {
                
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
        var qv_btn = jQuery(this).find('.cart-btn-content');
        jQuery(this).find('.qv-btn').appendTo(qv_btn);

        var prod_add = jQuery(this).find('.qv-btn');
        jQuery(this).find('.product-form').insertAfter(prod_add);

        var prod_add = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_add);

      });

      // style-2
      jQuery('.flex-slider > .product-card-two').each(function() {
                
       var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

         var prod_labl = jQuery(this).find('.time-counter');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_labl);

        var prod_rat = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(prod_rat);

        var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.price ').insertAfter(div_right);
        
        var div_right = jQuery(this).find('.product-content-top h3');
        jQuery(this).find('.product-content-top p ').insertAfter(div_right);

        var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').prependTo(prod_btn);

         var prod_sel = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_sel);
        
      });

      // style-3
      jQuery('.flex-slider > .product-card-three').each(function() {
                
         var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.cart-btn-main').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.label-sale').insertAfter(prod_btn);

        var label_btn = jQuery(this).find('.product-label-wrp');
        jQuery(this).find('.pro-label').appendTo(label_btn);

        var timer_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.time-counter').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.product-content-top');
        jQuery(this).find('.rating-wrapper').prependTo(rat_btn);

      });
    // style4

      jQuery('.flex-slider > .product-card-four').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn);

        var timer_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(timer_btn);

        var timer_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.price').insertAfter(timer_btn);
        
        var rat_btn = jQuery(this).find('.price');
        jQuery(this).find('.rating-wrapper').insertAfter(rat_btn);

         var rat_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.color-swatch-variants').insertAfter(rat_btn);

          var rat_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-wish').prependTo(rat_btn);

         var rat_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-compare').insertAfter(rat_btn);

      });

        // style5

      jQuery('.flex-slider > .product-card-five').each(function() {

         var prod_lable = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_lable);
        
          var prod_lable = jQuery(this).find('.pro-btn-wrapper');
         jQuery(this).find('.time-counter').insertAfter(prod_lable);

         var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.product-details').insertAfter(prod_btn);
        
        var prod_btn = jQuery(this).find('.product-details');
        jQuery(this).find('.price').prependTo(prod_btn);

          var prod_btn = jQuery(this).find('.price');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

      });

       // style6

        jQuery('.flex-slider > .product-card-six').each(function() {
  
        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);
  
        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);
  
        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);
  
        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);
  
         var prod_btn = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.pro-btn-wrapper').appendTo(prod_btn);
        
      });

        // style7

        jQuery('.flex-slider > .product-card-seven').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.product-image-bottom').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.time-counter').insertBefore(prod_btn2);

        var prod_rew = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_rew);

         var prod_btn = jQuery(this).find('.product-image-bottom');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_btn);
          
      });

      // style8

        jQuery('.flex-slider > .product-card-eight').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertBefore(prod_btn2);

        var prod_cart = jQuery(this).find('.product-content-top');
        jQuery(this).find('.add-to-cart').prependTo(prod_cart);

         var prod_btn = jQuery(this).find('.add-to-cart');
        jQuery(this).find('.color-swatch-variants').insertAfter(prod_btn);

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);
          
      });

         // style9

        jQuery('.flex-slider > .product-card-nine').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.time-counter').appendTo(prod_btn);

        var prod_label = jQuery(this).find('.product-card-image > a:last-child');
        jQuery(this).find('.pro-btn-wrapper').insertAfter(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn = jQuery(this).find('.product-content-top p');
        jQuery(this).find('.rating-wrapper').insertAfter(prod_btn);

          var prod_btn = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-form').prependTo(prod_btn);
          
      });

            // style-10

        jQuery('.flex-slider > .product-card-ten').each(function() {

        var prod_btn = jQuery(this).find('.product-card-image');
        jQuery(this).find('.rating-wrapper').appendTo(prod_btn);

        var prod_btn = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.time-counter').insertAfter(prod_btn);

        var prod_label = jQuery(this).find('.rating-wrapper');
        jQuery(this).find('.pro-btn-wrapper').insertBefore(prod_label);

        var prod_btn2 = jQuery(this).find('.pro-btn-wrapper');
        jQuery(this).find('.product-label-wrp').insertAfter(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.color-swatch-variants').prependTo(prod_btn2); 
          
        var prod_btn2 = jQuery(this).find('.product-content-bottom');
        jQuery(this).find('.product-form').appendTo(prod_btn2); 

        var prod_btn2 = jQuery(this).find('.product-form');
        jQuery(this).find('.price').insertBefore(prod_btn2); 
          
      });
       // end two-grid 
          },
          complete: function() {
              if (current_page_new < totalPages) {
                  // Re-enable load more button and hide loader
                  $('[loader]').addClass('hide');
              } else {
                  // Hide load more button if there are no more pages
                  $('[loader]').removeClass('hide');
              }
          }
      });
  }
  
  // Scroll event listener for infinite scroll
  $.fn.isInViewport = function() {
    var elementTop = this.offset().top;
    var elementBottom = elementTop + this.outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }; 
  $(window).on('scroll load', function() {
  if ($('.load-more_wrap').isInViewport()) {
          var currentPage = parseInt($('[data-this-page]').val());
          var nextUrl = $('[data-next-link]').val();
          var totalPages = parseInt($('[data-all-pages]').val());
          if (currentPage >= totalPages) {
//             // Hide loader and exit function
            $('[loader]').addClass('hide');
        }else{
          infiniteloadMoreProducts(nextUrl, totalPages);
          $('[loader]').removeClass('hide');
        }
  }
  });
  
}

//end infinite
   function countDownIni(countdown) {
   $(countdown).each(function () {
     var countdown = $(this);
     var promoperiod;
     if (countdown.attr('data-promoperiod')) {
       promoperiod = new Date().getTime() + parseInt(countdown.attr('data-promoperiod'), 10);
     } else if (countdown.attr('data-countdown')) {
       promoperiod = countdown.attr('data-countdown');
     }
     if (Date.parse(promoperiod) - Date.parse(new Date()) > 0) {
       $(this).addClass('countdown-block');
       countdown.countdown(promoperiod, function (event) {
         // countdown.html(event.strftime('%-w weeks %-d days %Hh %Mm %Ss'));
         countdown.html(event.strftime('<div class="days"><span class="count count-days">%D</span><span class="counter-dtl">days</span></div>' + '<div class="hour"><span class="count count-hours">%H</span><span class="counter-dtl">hrs</span></div>' + '<div class="mins"><span class="count count-minites">%M</span><span class="counter-dtl">mins</span></div>' + '<div class="secs"><span class="count count-seconds">%S</span><span class="counter-dtl">secs</span></div>'));
       });
     }
 
   });
 }